import Swiper from 'swiper';
import {
    Navigation,
    Pagination,
    A11y,
    Autoplay,
    Grid,
} from 'swiper/modules';

Swiper.use([Navigation, Pagination, A11y, Autoplay, Grid]);

function swiperMode() {
    let smallBreakpoint = window.matchMedia('(min-width: 0px) and (max-width: 960px)');
    let largeBreakpoint = window.matchMedia('(min-width: 961px)');

    if (smallBreakpoint.matches) {
        document.querySelectorAll('.swiper-container.disabled-on-desktop').forEach((container) => {
            if (container.swiper) return;

            const paginationEl = container.querySelector('.swiperPagination');
            const options = {
                slidesPerView: 1.1,
                spaceBetween: 8,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    400: {
                        slidesPerView: 1.2
                    },
                    577: {
                        slidesPerView: 2
                    },
                },
                ...(paginationEl ? {
                    pagination: {
                        el: paginationEl,
                        type: 'progressbar',
                        clickable: false,
                    },
                } : {}),
            };

            new Swiper(container, options);
        });
    } else if (largeBreakpoint.matches) {
        document.querySelectorAll('.swiper-container.disabled-on-desktop').forEach((container) => {
            if (!container.swiper) return;
            container.swiper.destroy(true, true);
        });
    }
}

window.addEventListener('load', swiperMode);
window.addEventListener('resize', swiperMode);

document.querySelectorAll('.swiperNewsSlider').forEach(function (thisSlider) {
    if (thisSlider.swiper) return;
    const swiper = new Swiper(thisSlider, {
        a11y: {
            enabled: true
        },
        breakpoints: {
            0: {
                slidesPerView: 1.2,
            },
            576: {
                slidesPerView: 2.1,
            },
            992: {
                slidesPerView: 3,
                spaceBetween: 16,
            },
            1200: {
                slidesPerView: 4,
            },
        },
    });
});

document.querySelectorAll('.swiperGallerySlider').forEach(function (thisSlider) {
    if (thisSlider.swiper) return;
    const container = thisSlider.closest('.swiperGalleryBlock');
    const nextButton = container.querySelector('.swiperGalleryNext');
    const prevButton = container.querySelector('.swiperGalleryPrev');

    const swiper = new Swiper(thisSlider, {
        slidesPerView: 1,
        spaceBetween: 8,        
        a11y: {
            enabled: true,
            slideRole: 'group',
        },
        navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
        },
        breakpoints: {
            0:   { slidesPerView: 1.6, spaceBetween: 8 },
            768: { slidesPerView: 2.4,   spaceBetween: 16 },
        },
    });
});

document.querySelectorAll('.filter-swiper').forEach((wrap) => {
    if (wrap.swiper) return;
    new Swiper(wrap, {
        slidesPerView: '4',
        freeMode: true,
        a11y: { 
            enabled: false,
        },
        breakpoints: {
            0:   { slidesPerView: 2.5 },
            576: { slidesPerView: 6.4 },
            768: { slidesPerView: 8.7 },
        },
    });
});


document.querySelectorAll('.swiperTestimonialsSlider').forEach((thisSlider) => {

    if (thisSlider.swiper) return;

    const container = thisSlider.closest('.testimonials-block');
    const nextButton = container.querySelector('.swiperTestimonialsNext');
    const prevButton = container.querySelector('.swiperTestimonialsPrev');

    new Swiper(thisSlider, {
        a11y: { 
            enabled: true,
        },
        navigation: { nextEl: nextButton, prevEl: prevButton },
        pagination: {
            el: container.querySelector('.swiperTestimonialsPagination'),
            type: 'progressbar',
            clickable: false,
        },
        breakpoints: {
            0:   { slidesPerView: 1.2, spaceBetween: 16 },
            576: { slidesPerView: 1.4, spaceBetween: 16 },
            768: { slidesPerView: 1.7, spaceBetween: 20 },
        },
    });
});

document.querySelectorAll('.swiperTwoColumnSlider').forEach((thisSlider) => {
    if (thisSlider.swiper) return;
    const container = thisSlider.closest('.two-column-slider');
    if (!container) return;
    const nextButton = container.querySelector('.swiperTwoColumnNext');
    const prevButton = container.querySelector('.swiperTwoColumnPrev');
    const pagination = container.querySelector('.swiperTwoColumnPagination');
    const navigation = (nextButton && prevButton) ? { nextEl: nextButton, prevEl: prevButton } : {};

    new Swiper(thisSlider, {
        a11y: { enabled: true },
        navigation,
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 16,
        pagination: {
            el: pagination,
            clickable: false,
        },
        breakpoints: {
            768: { spaceBetween: 24 },
        },
    });
});

document.querySelectorAll('.swiperFooterPartners').forEach((thisSlider) => {
    if (thisSlider.swiper) return;

    new Swiper(thisSlider, {
        a11y: {
            enabled: false,
        },
        allowTouchMove: false,
        centeredSlides: false,
        loop: true,
        loopAdditionalSlides: 8,
        speed: 4000,
        autoplay: {
            delay: 1,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
        },
        slidesPerView: 'auto',
        spaceBetween: 0,
        breakpoints: {
            992: {
                spaceBetween: 0,
            },
        },
    });
});
